import { jsx as _jsx } from "react/jsx-runtime";
import { FactSlogan as FreddyFactSlogan } from '@coolblue-development/freddy';
import { useTranslation } from '../../../i18n/useTranslation.js';
function FactSlogan({ isCustomerRecognised }) {
    const { t } = useTranslation('account');
    return (_jsx(FreddyFactSlogan, { fact: isCustomerRecognised ? t('factLoggedIn') : t('login'), slogan: isCustomerRecognised ? t('sloganLoggedIn') : t('sloganLoggedOut') }));
}
export default FactSlogan;
//# sourceMappingURL=FactSlogan.js.map